import { compose } from "redux";

// Base URL for the app - set based on environment / injected string
export function ApiBaseUrl() {
  const lookup: { [key: string]: string } = {
    'pfabankui-n.app.cloud.gov': 'https://pfabankapi-n.app.cloud.gov',
    'pfabankui-d.app.cloud.gov': 'https://pfabankapi-d.app.cloud.gov',
    'pfabankui-s.app.cloud.gov': 'https://pfabankapi-s.app.cloud.gov',
    'pfabankui-q.app.cloud.gov': 'https://pfabankapi-q.app.cloud.gov',
    'pfabankui.app.cloud.gov': 'https://pfabankapi.app.cloud.gov',
    'banks-n.data.fdic.gov': 'https://pfabankapi-n.app.cloud.gov',
    'banks-d.data.fdic.gov': 'https://pfabankapi-d.app.cloud.gov',
    'banks-s.data.fdic.gov': 'https://pfabankapi-s.app.cloud.gov',
    'banks-q.data.fdic.gov': 'https://pfabankapi-q.app.cloud.gov',
    'banks.data.fdic.gov': 'https://pfabankapi.app.cloud.gov',
    'localhost': 'http://localhost:3000',
  };

  return process.env.REACT_APP_API_BASE_URL || lookup[window.location.hostname];
}

// Set the limit for how many records the API will return (API limit ~10k)
export const apiResultLimit = 10000;

// Setup react DevTools
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
export const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Set Variables for App Base Path
// TODO: Need to re-examine approach to handling config
export const basePath = "/explore";
export const histPath = `${basePath}/historical`;
export const failPath = `${basePath}/failures`;
